import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  UpdateAddressPropertyInfoMutation as _UpdateAddressPropertyInfoMutation,
  UpdateAddressPropertyInfoInput,
} from '@/gql/graphql';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

const UpdateAddressPropertyInfoMutation = graphql(`
  mutation UpdateAddressPropertyInfo($input: UpdateAddressPropertyInfoInput!) {
    updateAddressPropertyInfo(input: $input) {
      publicId
      propertyInformation {
        propertyType
        builtForm
        constructionAgeBand
        floorAreaM2
        numBedrooms
        heatingSystem
        wallConstruction
        wallInsulation
        windowGlazingType
        loftInsulationMm
        numStoreys
      }
    }
  }
`);

const useUpdateAddressPropertyInfo = (
  options?: UseMutationOptions<
    _UpdateAddressPropertyInfoMutation,
    unknown,
    UpdateAddressPropertyInfoInput
  >
) => {
  return useMutation({
    mutationFn: (input: UpdateAddressPropertyInfoInput) => {
      return gqlClient.request(UpdateAddressPropertyInfoMutation, { input });
    },
    ...options,
  });
};

export default useUpdateAddressPropertyInfo;
